import React from 'react';

import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <path d="M18.2041 0.235413H2.2041C1.1041 0.235413 0.204102 1.13541 0.204102 2.23541V14.2354C0.204102 15.3354 1.1041 16.2354 2.2041 16.2354H18.2041C19.3041 16.2354 20.2041 15.3354 20.2041 14.2354V2.23541C20.2041 1.13541 19.3041 0.235413 18.2041 0.235413ZM18.2041 4.23541L10.2041 9.23541L2.2041 4.23541V2.23541L10.2041 7.23541L18.2041 2.23541V4.23541Z" />,
  'Email',
  { viewBox: '0 0 21 17' },
);
